// CUSTOM: bocket-multi-label-filter

const state = {
  selectedLabels: [], // array de label title strings
};

export const getters = {
  getSelectedLabelFilters: $state => $state.selectedLabels,
  hasActiveLabelFilter: $state => $state.selectedLabels.length > 0,
};

export const mutations = {
  TOGGLE_LABEL_FILTER: ($state, labelTitle) => {
    const idx = $state.selectedLabels.indexOf(labelTitle);
    if (idx === -1) {
      $state.selectedLabels = [...$state.selectedLabels, labelTitle];
    } else {
      $state.selectedLabels = $state.selectedLabels.filter(
        l => l !== labelTitle
      );
    }
  },
  CLEAR_LABEL_FILTERS: $state => {
    $state.selectedLabels = [];
  },
};

export const actions = {
  toggleLabelFilter({ commit }, labelTitle) {
    commit('TOGGLE_LABEL_FILTER', labelTitle);
  },
  clearLabelFilters({ commit }) {
    commit('CLEAR_LABEL_FILTERS');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
